import { Trans } from '@lingui/react/macro';
import { CheckCircle2, LogIn } from 'lucide-react';
import { memo } from 'react';

import { useChatRenderer } from '../../../ChatRendererProvider';
import { Markdown } from '../../../Markdown';
import { Message } from '../../../ui';

type MembershipLoginProps = {
  login: {
    content: string;
    shouldLogin: boolean;
  };
};

export const MembershipLogin = memo(function MembershipLogin({
  login,
}: MembershipLoginProps) {
  const { navigate, isEfitnessAuthenticated } = useChatRenderer();
  const { content, shouldLogin } = login;

  return (
    <Message.BubbleGroup>
      <Message.Bubble>
        {shouldLogin && isEfitnessAuthenticated?.() ? (
          <div className='flex items-center gap-2 text-green-600'>
            <CheckCircle2 className='size-5' />
            <Trans>You are logged in</Trans>
          </div>
        ) : (
          <Markdown>{content}</Markdown>
        )}
        {shouldLogin && !isEfitnessAuthenticated?.() && (
          <button
            type='button'
            onClick={() => navigate?.('signIn')}
            className='w-full my-3 flex flex-row items-center justify-center gap-2 rounded-lg bg-chat-secondary px-3 py-2.5 text-chat-secondary-foreground shadow drop-shadow transition-all enabled:hover:scale-105 enabled:hover:opacity-70 enabled:active:scale-100'
          >
            <LogIn className='size-5' />
            <Trans>Login</Trans>
          </button>
        )}
      </Message.Bubble>
    </Message.BubbleGroup>
  );
});
